import { useContext } from "react";

import { HeaderIds } from "src/helpers/uiConstants";
import { cn } from "src/lib/utils";
import { LanguageContext } from "./languageContext";
import { TextId } from "src/Translations";

export default function PageHeaderList() {
  const { translate } = useContext(LanguageContext);
  return (
    <div className="flex flex-col gap-2">
      {[
        { id: HeaderIds.aboutHeader, textId: "aboutThisStudy" },
        { id: HeaderIds.whatWeStudiedHeader, textId: "whatWeStudiedTitle" },
        { id: HeaderIds.whatWeMeasuredHeader, textId: "whatWeMeasuredTitle" },
        { id: HeaderIds.whatWeLearnedHeader, textId: "whatWeLearned" },
        {
          id: HeaderIds.circulationHeader,
          textId: "circulationChanges",
        },
        { id: HeaderIds.exampleTripsHeader, textId: "exampleTrips" },
        { id: HeaderIds.testYourOwnRouteHeader, textId: "testRouteHeader" },
      ].map(({ id, textId }) => (
        <a
          key={id}
          href={`#${id}`}
          className={cn(`underline hover:text-primary`)}
        >
          {translate(textId as TextId)}
        </a>
      ))}
    </div>
  );
}
